export default {
    init() {
		const self = this

        this.sliderInit()
				this.carouselInit()
        // this.socialSlider()
        this.imageCarousel()
        this.propertyCarousel()
        // this.blogCarousel()
				this.imageCarouselFullWidth()
        this.imageCarouselFull()
				this.imageCarouselFloorPlan()
        this.clientsTicker()
        this.apartmentSlider()
        this.testimonialsCarousel()

    },
    sliderInit(){

    const $heroSlider = $('#banner-slider')
		const $gallerySlider = $('.gallery-slider')
		const $heroSliderNav = $('#banner-slider-nav')

        // slick slider initiation
		if ($heroSlider.length) {
	        $heroSlider.slick({
	            centerPadding: '0',
	            infinite: false,
	            variableWidth: false,
	            draggable: true,
	            arrows: true,
				      dots: true,
	            fade: true,
	            autoplay: false,
	            autoplaySpeed: 6000,
	            pauseOnFocus: false,
				      slidesToShow: 1,
				      slidesToScroll: 1,
                prevArrow: $('.banner__arrows.prev'),
                nextArrow: $('.banner__arrows.next'),
                appendDots: $('.banner__dots'),
	              responsive: [
	                {
	                    breakpoint: 768,
	                    settings: {
                            //arrows: false,
	                        draggable: true,
	                    }
	                }
	            ]
	        })
		}

		if ($gallerySlider.length) {
					$gallerySlider.slick({
							centerPadding: '0',
							infinite: true,
							variableWidth: false,
							draggable: true,
							arrows: false,
							dots: true,
							fade: true,
							autoplay: true,
							autoplaySpeed: 6000,
							pauseOnFocus: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							prevArrow: $('.gallery-slider-left--prev'),
							nextArrow: $('.gallery-slider-right--next'),
							// responsive: [
							// 		{
							// 				breakpoint: 768,
							// 				settings: {
							// 							//arrows: false,
              //             infinite: true,
              //             variableWidth: false,
              //             prevArrow: $('.banner__arrows--prev'),
              //             nextArrow: $('.banner__arrows--next'),
              //             slidesToShow: 1,
            	// 						slidesToScroll: 1,
              //             dots: false,
							// 						draggable: true,
							// 				}
							// 		}
							// ]
					})
		}


    },

    testimonialsCarousel(){

    const $testCarousel = $('.testimonial-carousel')

        // slick slider initiation
		if ($testCarousel.length) {
	        $testCarousel.slick({
	            arrows: true,
							slidesToShow: 1,
							slidesToScroll: 1,
              dots: false,
              prevArrow: $('.arrow.prev.testimonial'),
              nextArrow: $('.arrow.next.testimonial'),
	        })
		}


    },

    clientsTicker(){

    const $slickCarousel = $('.scroll-list')

        // slick slider initiation
    if ($slickCarousel.length) {
          $slickCarousel.slick({
              slidesToShow: 3,
              variableWidth: true,
              slidesToScroll: 1,
              autoplay: true,
              infinite: true,
              arrows:false,
              autoplaySpeed: 0,
              speed: 9000,
              cssEase:'linear'
          })
    }


    },

    imageCarousel(){

    const $imageCarousel = $('.image-carousel')
		const $imageCarouselNav = $('.image-carousel-nav')

        // slick slider initiation
		if ($imageCarousel.length) {

	        $imageCarousel.slick({
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                // customPaging : function(slider, i) {
                // 		var thumb = $(slider.$slides[i]).data();
                // 		return '<a class="custom-navigation-item">'+(i+1)+'</a>';
                // },
                asNavFor: '.image-carousel-nav',
                prevArrow: $('.banner__arrows.prev'),
                nextArrow: $('.banner__arrows.next'),
                responsive: [
  	                {
  	                    breakpoint: 1024,
    	                    settings: {
    	                        draggable: true,
                              slidesToShow: 1,
                				      slidesToScroll: 1,
                              arrows: true,
                              dots: true,
    	                    }
    	                },
                      {
  	                    breakpoint: 480,
  	                    settings: {
  	                    draggable: true,
                        slidesToShow: 1,
              				  slidesToScroll: 1,
                        dots: true,
  	                    }
  	                }
  	            ]
	        })

            $imageCarouselNav.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false,
                asNavFor: '.image-carousel',
                dots: false,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                centerMode: false,
                focusOnSelect: true
            });
		}


    },

    propertyCarousel(){

    const $propertyCarousel = $('.property-slider')

        // slick slider initiation
    if ($propertyCarousel.length) {

          $propertyCarousel.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite:true,
                // lazyLoad: 'ondemand',
                prevArrow: $('.arrow.next'),
                nextArrow: $('.arrow.prev'),
          })
    }


    },

    blogCarousel(){

    const $blogCarousel = $('.blog-slider')

        // slick slider initiation
    if ($blogCarousel.length) {

          $blogCarousel.slick({
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                lazyLoad: 'ondemand',
                prevArrow: $('.arrow.prev.blog'),
                nextArrow: $('.arrow.next.blog'),
                responsive: [
                    {
                        breakpoint: 1024,
                          settings: {
                              draggable: true,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              arrows: true,
                              dots: false,
                          }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                        draggable: true,
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        }
                    }
                ]
          })
    }


    },

    socialSlider(){

    const $socialSlider = $('.social-slider')

        // slick slider initiation
    if ($socialSlider.length) {
          $socialSlider.slick({
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
          })
    }


    },

    imageCarouselFull(){

    const $imageCarousel = $('.image-carousel-full')

        // slick slider initiation
    if ($imageCarousel.length) {

          $imageCarousel.slick({
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                // customPaging : function(slider, i) {
                // 		var thumb = $(slider.$slides[i]).data();
                // 		return '<a class="custom-navigation-item">'+(i+1)+'</a>';
                // },
                prevArrow: $('.banner__arrows.prev'),
                nextArrow: $('.banner__arrows.next'),
                responsive: [
                    {
                        breakpoint: 1024,
                          settings: {
                              draggable: true,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              arrows: true,
                              dots: true,
                          }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                        draggable: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        }
                    }
                ]
          })
    }


    },

		imageCarouselFullWidth(){

		const $imageCarouselFullWidth = $('.carousel-full-width')

				// slick slider initiation
		if ($imageCarouselFullWidth.length) {

			$imageCarouselFullWidth.slick({
				arrows: false,
				centerMode: true,
				slidesToShow: 3,
				slidesToScroll: 1,
        speed:9000,
        cssEase: 'linear',
        infinite: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 0,
				arrows: false,
				dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                            settings: {
                            draggable: true,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: false,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            draggable: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false,
                        }
                    }
                ]
			})
		}


		},

    apartmentSlider(){

    const $apartmentSliderCenter = $('.team-list')

        // slick slider initiation
    if ($apartmentSliderCenter.length) {

      $apartmentSliderCenter.slick({
        centerMode: true,
        slidesToShow: 2,
        arrows: true,
        centerPadding: '100px',
        prevArrow: $('.arrow.prev.team'),
				nextArrow: $('.arrow.next.team'),
        dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                            settings: {
                            draggable: true,
                            slidesToShow: 1,
                            centerPadding: '10px',
                            centerMode: false,
                            slidesToScroll: 1,
                            centerMode: true,
                            arrows: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            centerMode: false,
                            draggable: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false,
                            arrows: true,
                        }
                    }
                ]
      })
    }

    /******************************
       BOTTOM SCROLL TOP BUTTON
    ******************************/

    // declare variable
    var scrollSlider = $(".apartment-arrow");

    // $(window).scroll(function() {
    //  // declare variable
    //  var topPos = $(this).scrollTop();
    //
    // }); // scroll END

    //Click event to scroll to top
    $(scrollSlider).click(function() {
     $('html, body').animate({
       scrollTop: $("#apartments-wrapper").offset().top
     }, 2000);
     return false;

    }); // click() scroll top EMD

    },

		imageCarouselFloorPlan(){

		const $imageCarouselFloorPlan = $('.carousel-floorplan')

				// slick slider initiation
		if ($imageCarouselFloorPlan.length) {

			$imageCarouselFloorPlan.slick({
				centerMode: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				arrows: true,
				prevArrow: $('.banner__arrows--prev'),
				nextArrow: $('.banner__arrows--next'),
				dots: true,
								responsive: [
										{
												breakpoint: 1024,
														settings: {
														draggable: true,
														slidesToShow: 1,
														slidesToScroll: 1,
														arrows: false,
														dots: true,
												}
										},
										{
												breakpoint: 480,
												settings: {
														draggable: true,
														slidesToShow: 1,
														slidesToScroll: 1,
														dots: true,
												}
										}
								]
			})
		}


		},

	carouselInit(){

		const self = this
        const $productCarousel = $('#product-carousel')

        // slick slider initiation
		if ($productCarousel.length) {
	        $productCarousel.slick({
	            centerPadding: '0',
				slidesToShow: 5,
				slidesToScroll: 1,
	            dots: false,
	            arrows: false,
	            fade: false,
	            autoplay: true,
	            autoplaySpeed: 3000,
	            pauseOnFocus: false,
				responsive: [
				{
			      breakpoint: 1400,
			      settings: {
					slidesToShow: 5,
	  	            slidesToScroll: 3,
			        infinite: true,
			      }
			    },
			    {
			      breakpoint: 1024,
			      settings: {
			        slidesToShow: 3,
			        slidesToScroll: 1,
			        infinite: true,
			      }
			    },
                {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: 2,
			        slidesToScroll: 1,
			        infinite: true,
			      }
			    },
				{
			      breakpoint: 400,
			      settings: {
			        slidesToShow: 2,
					dots: false,
			      }
			   },
			  ]
	        })

			$(window).on('resize', self.sliderReInit.bind(this))

		}

    },
	sliderReInit(){

		const $productCarousel = $('#product-carousel')

		if ($(window).width() < 400) {
			$productCarousel.slick('unslick')
			$productCarousel.slick()
		}
	},
}



// WEBPACK FOOTER //
// ./scripts/routes/slider.js